import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationsService} from "angular2-notifications";
import {UserService} from "../services/user.service";
// import {ReportService} from "../services/report.service";
import {PagerserviceService} from "../services/pagerservice.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {ExchangeService} from "../services/exchange.service";
import * as moment from 'moment'
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-tradereport',
    templateUrl: './tradereport.component.html',
    styleUrls: ['./tradereport.component.css']
})
export class TradereportComponent implements OnInit {
    FilPerpage: number;
    FilPage: number;
    pager: number;
    Tpager: number;
    mom:any
    fileName:string;
    pager1: any = {};
    orderslist = [];
    exportorderlist = [];
    today: any;
    orderslistFlag = false;
    currentPag:any = 0
    searchObj = {
        exchangetype: 'Buy',
        search: '',
        time1: new Date(),
        time: new Date(),
        perpage:0,
        page:0,
        _csrf:''
    }
    totalRecord =0;
    currentTime: string = moment().format('D-M-YYYY hh:mm a');
    permission: string;
    tradereport:boolean = false;
    settings = {
        bigBanner: true,
        format: 'dd-MMM-yyyy',
        defaultOpen: false,
        timePicker: true,
        closeOnSelect: true,
    }
    tradeobj:any = {};
    errorObj:any = {};
    userlist:Array<any> = []
    constructor(
                private userService: UserService,
                private router: Router,
                private route: ActivatedRoute,
                // private reportService: ReportService,
                private notif: NotificationsService,
                private pagerService: PagerserviceService,
                private exchangeService: ExchangeService,
                private spinnerService: Ng4LoadingSpinnerService) {
    }
    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            if(typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length>0)
            {
                var spt = this.router.url.split("/");
                var menu_url = spt[1];
                var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
                var adminrules = JSON.parse(localStorage.getItem('adminrules'));
                var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
                if(index!=-1)
                {
                    var menuid = adminmenus[index]._id;
                    var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
                    this.permission = (adindex!=-1)?adminrules[adindex].permission:"write";
                }
            }
            var d = new Date();
            this.searchObj.time=new Date(d.setDate(d.getDate()));
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.csrf();
            this.exchangeService.CompleteOrderEvent.subscribe(price => {
                this.getUserReports();
            })
            // this.getCustomerList();
        }
    }
    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.searchObj._csrf = success._csrf;
            this.getUserReports();
        }, (error) => {
            if(error.status>0) {
                this.notif.error(
                    'CSRF',
                    error.error.message,
                    {
                        timeOut: 5000,
                        showProgressBar: true,
                        pauseOnHover: true,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }
        })
    }
    // getCustomerList(){
    //     this.userService.getCustomers( this.searchObj._csrf).subscribe((success) => {
    //         this.userlist = success.result;            
    //     })
    // }
    getUserReports() {
        this.spinnerService.show();
        this.searchObj.perpage= this.FilPerpage;
        this.searchObj.page = this.FilPage;
        // this.reportService.getAdminTradeReport(this.searchObj,false).subscribe((success) => {
        //     this.orderslist = [];
        //     this.spinnerService.hide();
        //     if(success.transactions.trade == undefined || success.transactions.trade == null){
            
        //     }
        //     else{
        //         this.orderslist = success.transactions.trade;
        //         this.Tpager = success.pages;
        //         this.totalRecord = success.total;
        //         this.currentPag = success.current
        //         this.setPage(this.FilPage);
        //         this.orderslistFlag = true;
        //     }
        // }, (error) => {
        //     this.spinnerService.hide();
        //     this.notif.error(
        //         'Order List',
        //         error.error.message,
        //         {
        //             timeOut: 5000,
        //             showProgressBar: true,
        //             pauseOnHover: true,
        //             clickToClose: true,
        //             maxLength: 50
        //         }
        //     )
        // })
    }

    getUserReportsexp() {
        this.spinnerService.show();
        this.searchObj.perpage= this.FilPerpage;
        this.searchObj.page = this.FilPage;
        // this.reportService.getAdminTradeReport(this.searchObj,true).subscribe((success) => {
        //     var orderslist = [];
        //     this.spinnerService.hide();
        //     if(success.transactions.trade == undefined || success.transactions.trade == null){
            
        //     }
        //     else{
        //         orderslist = success.transactions.trade;
        //         var exportorderlist = [];
        //         var convertionrate = 0;
        //         var totalamount= 0;
        //         for(let i = 0; i< orderslist.length; i++){
        //             if(this.currentCurrency=='EUR'){
        //                 totalamount = orderslist[i].totalamount.toFixed(2) * orderslist[i].eur_conversion;
        //                 convertionrate =  orderslist[i].eur_conversion;
        //             }else if (this.currentCurrency=='INR'){
        //                 totalamount = orderslist[i].totalamount.toFixed(2) * orderslist[i].inr_conversion;
        //                 convertionrate =  orderslist[i].inr_conversion;

        //             }else if(this.currentCurrency=='USD'){
        //                 totalamount = orderslist[i].totalamount.toFixed(2) * orderslist[i].usd_conversion;
        //                 convertionrate =  orderslist[i].usd_conversion;
        //             }else{}
        //             exportorderlist.push({
        //                 "Business name"           : "Blockoville",
        //                 "Blockoville client Order Id" : orderslist[i].clienttradeid,
        //                 "User Id"                 : orderslist[i].customer.userid,
        //                 "User Name"               : orderslist[i].customer.name,
        //                 "Pair"                    : orderslist[i].pair,
        //                 "Type"                    : orderslist[i].exchangetype,
        //                 "Traded Price"            : orderslist[i].price,
        //                 "Quantity"                : orderslist[i].orderamount.toFixed(5),
        //                 "MV Local"                : orderslist[i].totalamount.toFixed(2),
        //                 "Convertion rate"         : convertionrate,
        //                 "MV Currency"                  : totalamount,
        //                 "Trade timestamp"         : orderslist[i].createdAt,
        //                 "User Trade Order ID"     : orderslist[i].uniqorderId,
        //                 "Tradeid"                 : orderslist[i].tradeid,
        //             })
        //           }
        //         this.fileName = 'UserTradeReport.xlsx'
        //         const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportorderlist);

        //         /* generate workbook and add the worksheet */
        //         const wb: XLSX.WorkBook = XLSX.utils.book_new();
        //         XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        //         /* save to file */
        //         XLSX.writeFile(wb, this.fileName);
        //     }
        // }, (error) => {
        //     this.spinnerService.hide();
        //     this.notif.error(
        //         'Order List',
        //         error.error.message,
        //         {
        //             timeOut: 5000,
        //             showProgressBar: true,
        //             pauseOnHover: true,
        //             clickToClose: true,
        //             maxLength: 50
        //         }
        //     )
        // })
    }

    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page:number){
        this.pager = page;
        this.FilPage =this.pager;
        this.getUserReports();
    }
    /**
     * 
     * @param report export excel
     */
    exportExcel(report){
        this.fileName = 'UserTradeReport.xlsx'
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.exportorderlist);
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            /* save to file */
            XLSX.writeFile(wb, this.fileName);
    }
    /**
     * 
     * @param obj 
     */
    tradeForm(obj:any){
        console.log(obj);
        if(obj == 'show'){
            this.tradereport = false;
        }else if (obj == 'hide'){
            this.tradereport = true;
        }else{}
    }
    clearError(field) {
        switch (field) {
            case 'name':
                this.errorObj.name = '';
                break;
            }
    }
    selectedUser(data){
        this.tradeobj['userid'] = data.target.value;
    }
    addTradeReport(customerDetails, traderep){
        this.tradeobj['pair'] = this.tradeobj['from'] + this.tradeobj['to']
        this.tradeobj['clienttradeid'] = Math.floor(Math.random() * 100000000000);
        this.tradeobj['tradeid'] = Math.floor(Math.random() * 100000000000);
        this.tradeobj['status'] = 'Completed';
        this.tradeobj['orderid'] = 'BLO'+Math.floor(Math.random() * 100000000000);
        this.tradeobj['uniqorderId'] = 'BLO'+Math.floor(Math.random() * 100000000000);
        this.tradeobj["dateTime"] = new Date(this.tradeobj["dateTime"]).toISOString();
        this.userService.csrf().subscribe((success) => {
            this.tradeobj['_csrf'] = success._csrf;
            this.getUserReports();
            this.userService.saveTradeReport(this.tradeobj).subscribe((success) => {
                this.notif.success(
                    'Success',
                    success.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
                traderep.resetForm({})
            },(err)=>{
                this.notif.error(
                    'Error',
                    err.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            })
        })
    }
    currentCurrency:any='EUR';
    ChangeCurrency(event){
        this.currentCurrency = event.target.value
    }
}




// WEBPACK FOOTER //
// ./src/app/tradereport/tradereport.component.ts